<template>
    <v-dialog :value="true" persistent max-width="500" scrollable>
        <v-card style="border-radius: 16px; overflow: hidden;">
            <v-toolbar :color="$theme.primary" dark flat dense>
                <v-icon left>mdi-shield-lock-outline</v-icon>
                <v-toolbar-title class="text-subtitle-1">Confirme com seu banco</v-toolbar-title>
                <v-spacer/>
                <v-btn icon small @click="$emit('cancelar')">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>

            <v-card-text class="pa-0">
                <div class="text-center caption grey--text px-4 py-2">
                    Para sua segurança, o débito precisa ser autenticado no seu banco.
                </div>

                <!-- Form que dispara o challenge 3DS dentro do iframe -->
                <form ref="form" :action="externalResourceUrl" method="POST" target="challengeFrame">
                    <input type="hidden" name="creq" :value="creq"/>
                </form>

                <iframe
                    name="challengeFrame"
                    title="Autenticação do banco (3D Secure)"
                    style="width: 100%; height: 430px; border: 0; display: block;"
                />
            </v-card-text>

            <v-card-actions class="justify-center">
                <v-btn text small :color="$theme.primary" @click="$emit('verificar')">
                    Já confirmei — verificar pagamento
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'Challenge3DS',

    props: {
        externalResourceUrl: { type: String, required: true },
        creq: { type: String, required: true },
    },

    mounted() {
        // Dispara o desafio do banco dentro do iframe assim que o componente monta.
        this.$nextTick(() => {
            if (this.$refs.form) {
                this.$refs.form.submit();
            }
        });
    },
};
</script>
